import { Injectable, signal } from '@angular/core';

@Injectable({providedIn: 'root'})
export class SidebarService {
  collapseEnabled = signal(this.getInitialState());

    toggleSidebar(): boolean {
      const newValue = !this.collapseEnabled();
      this.collapseEnabled.set(newValue);
      localStorage.setItem('sidebar', newValue ? 'collapsed' : 'expanded');
      return newValue;
    }



    private getInitialState(): boolean {
      return localStorage.getItem('sidebar') === 'collapsed';
    }
}
